import { render, staticRenderFns } from "./LayoutFixedCenterModel.vue?vue&type=template&id=14480544&scoped=true&"
import script from "./LayoutFixedCenterModel.vue?vue&type=script&lang=js&"
export * from "./LayoutFixedCenterModel.vue?vue&type=script&lang=js&"
import style0 from "./LayoutFixedCenterModel.vue?vue&type=style&index=0&id=14480544&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14480544",
  null
  
)

export default component.exports